
( function($) {
  $(document).ready(function() {

      'use strict';
      $('.select2-js-target').select2({
        theme: 'classic'
      });


      // $('.select-wrapper').find('.down-arrow').on("click", function(){
      //     // console.log('asdasd');
      //    $(this).closest('.select-wrapper').find('select').trigger('click');
      //
      //     $('.select2-js-target').trigger('click');
      // });


  })
}(jQuery));
